<template>
    <section>
        <div class="pro_section2" style="display: flex; align-items: center; position: relative;">
            <div class="mobile_con_wrap" style="padding-top: 80px; padding-bottom: 200px">
                <div style="display: flex; flex-direction: column; align-items: flex-start;">
                    <img src="@/assets/images/main_v2/icon/logo_pulda.svg" alt="" style="width: 65px; height: 65px; margin-bottom: 26px">
                    <div style="display: flex; flex-direction: column; align-items: flex-start; justify-content: flex-end; margin-bottom: 44px;">
                        <p style="font-size: 25px; font-weight: 700; line-height: 1.5; text-align: center; color: #000000; margin-bottom: 8px;">
                            공부가 필요한 순간, 풀다
                        </p>
                        <p style="font-size: 18px; font-weight: 700; line-height: 1.5; text-align: center; color: #000000;">
                            학생 플랫폼
                        </p>
                    </div>
                    <p data-aos="fade-right"
                        data-aos-delay="0"
                        data-aos-once="true"
                        data-aos-duration="600"
                        data-aos-easing="ease-in-out" style="font-size: 15px; font-weight: 400; text-align: left; color: #5A5A5A; line-height: 1.5;">
                        풀다는 인공지능 기술을 통해 나에게 꼭 필요한 문제만 풀 수 있는
                        AI 학습 플랫폼입니다. 자투리 시간을 활용한 학습으로도 성적 상승을
                        경험할 수 있습니다. 풀다를 통해 효율적인 학습을 시작해보세요!
                        <!-- 필드유 팀원들은 이렇게 생각하고 임하고 있습니다.
                        우리가 지향하는 목표를 계속 잊지 않고 크고 작은 목표들을 달성해나갈 때마다 어느새 우리는 우리가
                        목표로 세웠던 방향에 도달할 수 있을 것입니다. 우리는 교육의 혁신을 이루어내고자 함께 모였으며,
                        앞으로도 우리는 계속해서 고민을 하고, 답을 찾을 것입니다. -->
                    </p>
                    <div style="display: flex; justify-content: space-between; overflow-x: hidden;">
                        <div style="width: calc(50% - 16px); display: flex; align-items: flex-start; flex-direction: column; justify-content: center;">
                            <div @click="openLink(webUrl)" class="btn_link" style="margin-bottom: 13px">
                                <img class="btn_logo" src="@/assets/images/main_v2/icon/shortcut.svg" alt="">
                                <p class="web" style="font-size: 13px; font-weight: 700; margin-left: 5px; line-height: 1.2;">Web</p>
                            </div>
                            <div @click="openLink(googleUrl)" class="btn_link" style="margin-bottom: 13px">
                                <img src="@/assets/images/main_v2/icon/googleplay.svg" alt="" style="width: 18px; height: 18px">
                                <p style="font-size: 13px; font-weight: 700; margin-left: 5px; color: black; line-height: 1.2">Google Play</p>
                            </div>
                            <div @click="openLink(appleUrl)" class="btn_link">
                                <img class="btn_logo" src="@/assets/images/main_v2/icon/appstore.svg" alt="">
                                <p style="font-size: 13px; font-weight: 700; margin-left: 5px; color: black; line-height: 1.2">App Store</p>
                            </div>
                        </div>
                        <img data-aos="fade-left"
                            data-aos-delay="400"
                            data-aos-once="true"
                            data-aos-duration="600"
                            data-aos-easing="ease-in-out" src="@/assets/images/main_v2/mobile.png" alt="" style="width: 50%">
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
import { ChevronDownIcon } from 'vue-feather-icons'
export default {
    components: {
        ChevronDownIcon,
    },
    data() {
        return {
            webUrl: "https://www.pulda.net",
            appleUrl: "https://apps.apple.com/app/id1530892838",
            googleUrl:
                "https://play.google.com/store/apps/details?id=com.filledu.pulda2",
        }
    },
    methods: {
        openLink(val) {
            window.open(val, '_blank')
        }
    }
    
}
</script>
<style>
    .pro_section2 {
        width: 100vw;
        background: white;
        object-fit: inherit;
    }
    .pro_section2 .btn_link {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 11px 16px;
        border: 3px solid #1C9CD3;
        border-radius: 10px;
        cursor: pointer;
    }
    .btn_link .web {
        color: #1C9CD3;
    }
    .btn_link .btn_logo {
        width: 18px;
        height: 18px;
        opacity: 1;
    }
</style>